var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "@rentiohq/web-theme";
export var StyledScrollable = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  -webkit-overflow-scrolling: touch;\n  position: relative;\n  ", "\n  ", "\n"], ["\n  -webkit-overflow-scrolling: touch;\n  position: relative;\n  ", "\n  ", "\n"])), function (_a) {
    var horizontal = _a.horizontal;
    return horizontal &&
        "\n    overflow-x: auto;\n  ";
}, function (_a) {
    var vertical = _a.vertical;
    return vertical &&
        "\n    overflow-y: auto;\n  ";
});
var templateObject_1;
